
import {
  getCustomers,
  getProductsInfo,
  getSuppliers
} from '../api'

export async function queryCustomers (name) {
  return (await getCustomers({ name: name }))
    .data
    .map(c => ({ value: c.id, label: c.name, data: c }))
}

export async function querySuppliers (name) {
  return (await getSuppliers({ name: name }))
    .data
    .map(c => ({ value: c.id, label: c.name, data: c }))
}

export async function queryProducts (name) {
  return (await getProductsInfo({ name: name }))
    .data
    .map(p => ({ value: p.name }))
}
